import gql from 'graphql-tag'

export const fragments = {
	employee: gql`
		fragment employee on User {
			id
			firstName
			lastName
			phoneNumber
			bookingEnabled
			photo
			notifyBy
			bio
		}
	`,
}
export const employeesQuery = gql`
	query employees {
		employees {
			...employee
			permissionLevel
			email
			locations {
				id
			}
			services {
				id
			}
		}
	}

	${fragments.employee}
`

export const employeeQuery = gql`
	query employee($input: EmployeeQueryInput!) {
		employee(input: $input) {
			...employee
			portfolioPhotos {
				url
				key
			}
			permissionLevel
			email
			uuid
			locations {
				id
			}
			services {
				id
			}
		}
	}

	${fragments.employee}
`

export const employeeSchedulesByLocation = gql`
	query employeeSchedulesByLocation($employees: EmployeeQueryInput, $ranges: SchedulesInput!) {
		employees(input: $employees) {
			...employee
			schedule_ranges(input: $ranges) {
				id
				start_date
				end_date
				day_of_week
				schedule_shifts {
					start_time
					end_time
					acceptingAppointments
					acceptingWalkins
					acceptingCheckins
				}
			}
		}
	}

	${fragments.employee}
`
